export default __webpack_public_path__ + "static/media/plus-icon.4015e05a.svg";